import React, { useRef, useEffect } from 'react';
import { motion } from 'framer-motion';

const DownloadPage = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Ensure video plays and loops
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.log('Video autoplay prevented:', error);
      });
    }
  }, []);

  return (
    <div className="relative w-full h-screen overflow-hidden bg-black">
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
          style={{ filter: 'brightness(0.4)' }}
        >
          <source src="/assets/montage_clips.mp4" type="video/mp4" />
        </video>
        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col h-full justify-between items-center px-6 py-12">
        {/* Top: Pixley Logo/Text */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="text-center mt-8 sm:mt-12"
        >
          <h1
            className="text-6xl sm:text-7xl md:text-8xl font-bold text-white mb-4"
            style={{
              fontFamily: "'Fredoka', 'Comic Sans MS', cursive, sans-serif",
              fontWeight: 700,
              letterSpacing: '0.05em',
              textShadow: '0 4px 20px rgba(0, 0, 0, 0.8), 0 2px 10px rgba(102, 126, 234, 0.3)',
            }}
          >
            PIXLEY
          </h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="text-xl sm:text-2xl text-white/90 font-medium"
            style={{
              fontFamily: "'Fredoka', 'Comic Sans MS', cursive, sans-serif",
              textShadow: '0 2px 10px rgba(0, 0, 0, 0.6)',
            }}
          >
            Personalized Kids Stories
          </motion.p>
        </motion.div>

        {/* Bottom: Download Button */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5, ease: 'easeOut' }}
          className="mb-8 sm:mb-12 w-full flex justify-center items-center"
        >
          <a
            href="https://apps.apple.com/app/apple-store/id6751121342?pt=128151348&ct=pixley-download&mt=8"
            target="_blank"
            rel="noopener noreferrer"
            className="block transition-transform duration-300 hover:scale-105 active:scale-95"
          >
            <img
              src="/assets/download_on_app_store.svg"
              alt="Download on the App Store"
              className="h-14 sm:h-16 md:h-20 w-auto drop-shadow-2xl"
              style={{
                filter: 'drop-shadow(0 8px 24px rgba(0, 0, 0, 0.4))',
              }}
            />
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default DownloadPage;

